import dayjs from 'dayjs';

const extendedAgentTournament = {
  start: '2026-08-01T00:00:00-03:00',
  end: '2026-09-30T23:59:59-03:00',
  dateMonth: '2026-08',
};

const isExtendedAgentTournamentActive = () => {
  const now = dayjs().valueOf();
  const start = dayjs(extendedAgentTournament.start).valueOf();
  const end = dayjs(extendedAgentTournament.end).valueOf();

  return now >= start && now <= end;
};

const getCurrentAgentTournamentMonth = () => {
  if (isExtendedAgentTournamentActive()) {
    // Длинные турниры не привязаны к текущему календарному месяцу.
    // Держим весь турнир на месяце его старта, чтобы "previous" вел
    // на месяц перед турниром, а не на месяц перед сегодняшней датой.
    return extendedAgentTournament.dateMonth;
  }

  return dayjs().format('YYYY-MM');
};

const getCurrentAgentTournamentMonthState = () => {
  if (isExtendedAgentTournamentActive()) {
    return {
      value: undefined,
      month: 'current',
    };
  }

  return {
    value: dayjs().format('YYYY-MM'),
    month: 'current',
  };
};

const getPreviousAgentTournamentMonth = currentMonth => {
  const baseMonth = currentMonth || getCurrentAgentTournamentMonth();

  return dayjs(`${baseMonth}-01`).subtract(1, 'month').format('YYYY-MM');
};

const getAgentTournamentEndDate = () => (isExtendedAgentTournamentActive() ? extendedAgentTournament.end : null);

export { getAgentTournamentEndDate, getCurrentAgentTournamentMonthState, getPreviousAgentTournamentMonth };
